const UPDATE_USERNAME_SIZE = 'UPDATE_USERNAME_SIZE';
const UPDATE_USERNAME_CLEAR = 'UPDATE_USERNAME_CLEAR';
const UPDATE_USERNAME_CONTAINERS_SIZE = 'UPDATE_USERNAME_CONTAINERS_SIZE';

export { UPDATE_USERNAME_SIZE, UPDATE_USERNAME_CLEAR, UPDATE_USERNAME_CONTAINERS_SIZE };
